import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError, ApiResponse } from "./responses/AxiosResponseHandler";
import { getCurrentCity } from "../utils/currentCity";
import { PartyModel } from "../types";
import { parseMyPartyResponse } from "./parseResponse/parseMyPartiesResponse";
import MyPartyResponse from "./responses/apiResponses";

class NewSeenGroupsApi {

    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async getMyNewParties(): Promise<ApiResponse<PartyModel[]> | undefined> {

        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const cityID = getCurrentCity(authenticationResponse)?.cityId;

            if (!cityID) {
                console.error("Current city is missing.");
            }

            const response = await axios.get(
                `${this.authClient.getApiRoot()}/Cities/${cityID}/groups`,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
                data: (response.data as MyPartyResponse[]).map(parseMyPartyResponse),
            };

        } catch (error) {
            const errorResponse = handleAxiosError<PartyModel[]>(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
                data: errorResponse.data
            }
        }
    }
}

export default NewSeenGroupsApi;
